import {connect} from 'react-redux';
import {ProtocolTable as Component} from './ProtocolTable';
import {
  showModal,
  setProtocolTableData
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    tableData: state.notebook.protocolSection.tableData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setProtocolTableData: (data) => {
      dispatch(setProtocolTableData(data))
    }
  };
}

export const ProtocolTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
